import React, { useState } from 'react';
import { useTable, usePagination } from 'react-table'

function DataTable({
    columns,
    data,
    fetchData,
    loading,
    pageCount: controlledPageCount,
    isPaginable,
    classNameDiv,
    refresh,
    pSize,
    activeTotalEvent,
    totals,
    getRowProps,
    getHeadProps
}) {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        // Get the state from the instance
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: 0, pageSize: (pSize !== null && pSize !== undefined && pSize > 0) ? pSize : 10 }, // Pass our hoisted table state
            manualPagination: true, // Tell the usePagination
            // hook that we'll handle our own data fetching
            // This means we'll also have to provide our own
            // pageCount.
            pageCount: controlledPageCount,
        },
        usePagination
    )

    const [pagerButtons, setPagerButtons] = useState([]);



    const computePaginationButtons = () => {
        pagerButtons.length = 0; //.splice(0,pagerButtons.length);

        //setPagerButtons(pagerButtons=>pagerButtons=[])        

        for (let index = 0; index < pageCount; index++) {
            pagerButtons.push(index);
        }
    }

    const [IsPaginable, setIsPaginable] = useState(false);

    const [limitIndex, setLimitIndex] = useState(10);
    const [startIndex, setStartIndex] = useState(0);

    const moveNextPages = () => {

        let newLimitIndex = limitIndex + 10
        let newStartIndex = startIndex + 10
        if (newLimitIndex > pageCount) {
            let ecart = newLimitIndex - pageCount
            newLimitIndex = pageCount;
            newStartIndex = newStartIndex - ecart;
        }
        setLimitIndex(newLimitIndex)
        setStartIndex(newStartIndex)
        gotoPage(newStartIndex)
    }

    const movePreviousPages = () => {
        let newLimitIndex = limitIndex - 10
        let newStartIndex = startIndex - 10
        if (newStartIndex < 0) {
            let ecart = newStartIndex * -1;
            newStartIndex = 0;
            newLimitIndex = newLimitIndex + ecart;
        }

        setLimitIndex(newLimitIndex)
        setStartIndex(newStartIndex)
        gotoPage(newStartIndex)
    }


    //Check here the performance for refreshing
    // Listen for changes in pagination and use the state to fetch our new data
    React.useEffect(() => {
        /*console.log(pageIndex)
        console.log(pageSize)
        console.log(pageCount)*/
        fetchData({ pageIndex, pageSize })
        //console.log(isPaginable)
        if (isPaginable !== null && isPaginable !== undefined) {
            setIsPaginable(isPaginable);
            computePaginationButtons();
        }
    }, [fetchData, pageIndex, pageSize, pageCount])

    React.useEffect(() => {
        if (pageCount !== null && pageCount !== undefined && pageCount > 1) {
            computePaginationButtons();
        }
    }, [pageCount])

    React.useEffect(() => {
        if (pageIndex > limitIndex && pageIndex === pageCount - 1) {
            setLimitIndex(pageIndex + 1)
            setStartIndex(pageIndex - 9)
        }
        else if (pageIndex === 0) {
            setStartIndex(0);
            if (pageCount > 11) {
                setLimitIndex(10);
            }
            else if (pageCount > 0) {
                setLimitIndex(pageCount - 1);
            }
        }
    }, [pageIndex])

    const buildBigPager = () => {
        var rows = [];
        /*console.log("build big pager");
        console.log("startIndex = " + startIndex);
        console.log("limitIndex = " + limitIndex);
        console.log("pageCount = " + pageCount);*/
        if (pagerButtons.length > 11) {
            if (startIndex > 0) {
                rows.push(<li key={startIndex + 'P'} className="page-item"><button type="button" onClick={() => movePreviousPages()} className="page-link">...</button></li>)
            }
            for (let index = startIndex; index <= limitIndex; index++) {
                if (index === limitIndex) {
                    if ((limitIndex + 1) < pageCount) {
                        rows.push(<li key={index} className="page-item"><button type="button" onClick={() => moveNextPages()} className="page-link">...</button></li>);
                    }
                    return rows;
                }
                rows.push(<li key={index} className={pageIndex == index ? "page-item active" : "page-item"}><button type="button" onClick={() => gotoPage(index)} className="page-link">{index + 1}</button></li>)
            }
        }
        return rows;
    }

    // Render the UI for your table
    return (
        <>
            <div className={`table-wrapper ${classNameDiv}`}>
                <table {...getTableProps()} className="table table-striped mb-0">
                    <thead>
                        {headerGroups.map((headerGroup, index) => index > 0 && (
                            <tr {...headerGroup.getHeaderGroupProps()} {...getHeadProps}>
                                {headerGroup.headers.map(column => (
                                    <th {...column.getHeaderProps({ className: column.classNameHeader })} scope="col">
                                        {column.render('Header')}
                                        <span>
                                            {column.isSorted
                                                ? column.isSortedDesc
                                                    ? ' 🔽'
                                                    : ' 🔼'
                                                : ''}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {page.map((row, i) => {
                            prepareRow(row)
                            return (
                                <tr {...row.getRowProps()} {...getRowProps}>
                                    {row.cells.map(cell => {
                                        return <td {...cell.getCellProps({ className: cell.column.className })} >{cell.render('Cell')}</td>
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                    {activeTotalEvent !== null && activeTotalEvent !== undefined && activeTotalEvent === true && totals !== null && totals !== undefined && totals.length > 0 &&
                        <thead>
                            <tr>
                                <th scope="col" colSpan="2">Total</th>
                                <th scope="col" className="text-center">{totals[0]}</th>
                                <th scope="col" className="text-center">{totals[1]}</th>
                            </tr>
                        </thead>
                    }
                </table>
            </div>
            {IsPaginable && pageCount > 1 && pagerButtons !== null && pagerButtons !== undefined && pagerButtons.length > 0 &&

                <ul className="pagination mb-4">
                    <li className={!canPreviousPage ? "page-item disabled" : "page-item"} aria-label="Previous">
                        <button type="button" className="page-link" onClick={() => gotoPage(0)} tabIndex="-1" aria-disabled="true">
                            <span aria-hidden="true">
                                <svg width="7" height="12" viewBox="0 0 7 12" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M-2.07663e-05 6.00002C-2.07569e-05 6.21508 0.0820959 6.43012 0.245983 6.59409L5.40578 11.7538C5.734 12.0821 6.26617 12.0821 6.59426 11.7538C6.92236 11.4257 6.92236 10.8937 6.59426 10.5654L2.02859 6.00002L6.5941 1.43459C6.9222 1.10636 6.9222 0.574357 6.5941 0.24629C6.26601 -0.0820961 5.73384 -0.0820961 5.40562 0.24629L0.245824 5.40595C0.0819094 5.57 -2.07757e-05 5.78504 -2.07663e-05 6.00002Z"
                                        fill="#4C5673" />
                                </svg>
                            </span>
                        </button>
                    </li>
                    {
                        pagerButtons.length <= 11 && pagerButtons.map((row, index) => <li key={index} className={pageIndex == row ? "page-item active" : "page-item"}><button type="button" onClick={() => gotoPage(row)} className="page-link">{row + 1}</button></li>)
                    }
                    {
                        pagerButtons.length > 11 && buildBigPager()
                    }
                    <li className={!canNextPage ? "page-item disabled" : "page-item"}>
                        <a className="page-link" onClick={() => { gotoPage(pageCount - 1) }} aria-label="Next">
                            <span aria-hidden="true">
                                <svg width="7" height="12" viewBox="0 0 7 12" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.84047 6.00002C6.84047 6.21508 6.75836 6.43012 6.59447 6.59409L1.43468 11.7538C1.10645 12.0821 0.574287 12.0821 0.246193 11.7538C-0.0819014 11.4257 -0.0819014 10.8937 0.246193 10.5654L4.81186 6.00002L0.246353 1.43459C-0.0817415 1.10636 -0.0817415 0.574357 0.246353 0.24629C0.574447 -0.0820961 1.10661 -0.0820961 1.43484 0.24629L6.59463 5.40595C6.75854 5.57 6.84047 5.78504 6.84047 6.00002Z"
                                        fill="#4C5673" />
                                </svg>
                            </span>
                        </a>
                    </li>
                </ul>
            }
            {/*
        <div className="pagination">
          <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
            {'<<'}
          </button>{' '}
          <button onClick={() => previousPage()} disabled={!canPreviousPage}>
            {'<'}
          </button>{' '}
          <button onClick={() => nextPage()} disabled={!canNextPage}>
            {'>'}
          </button>{' '}
          <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
            {'>>'}
          </button>{' '}
          <span>
            Page{' '}
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>{' '}
          </span>
          <span>
            | Go to page:{' '}
            <input
              type="number"
              defaultValue={pageIndex + 1}
              onChange={e => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0
                gotoPage(page)
              }}
              style={{ width: '100px' }}
            />
          </span>{' '}
          <select
            value={pageSize}
            onChange={e => {
              setPageSize(Number(e.target.value))
            }}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </div>*/}
        </>
    )
}

export default DataTable;